import { render } from "./huxi.vue?vue&type=template&id=553fbdb2&scoped=true"
import script from "./huxi.vue?vue&type=script&lang=js"
export * from "./huxi.vue?vue&type=script&lang=js"

import "./huxi.vue?vue&type=style&index=0&id=553fbdb2&lang=scss"
import "./huxi.vue?vue&type=style&index=1&id=553fbdb2&scoped=true&lang=css"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553fbdb2"]])

export default __exports__